import { render, staticRenderFns } from "./BottomCredits.vue?vue&type=template&id=29a729d4&scoped=true&"
import script from "./BottomCredits.vue?vue&type=script&lang=js&"
export * from "./BottomCredits.vue?vue&type=script&lang=js&"
import style0 from "./BottomCredits.vue?vue&type=style&index=0&id=29a729d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a729d4",
  null
  
)

export default component.exports